import React from 'react';
import styles from './subCategoriesContainer.module.css';
import { Link } from 'react-router-dom';
import { ICategory } from "../../../services/model/Category";

interface ItemsContainerProps {
    categories: ICategory[];
    activeCategory: string | null;
    drillPath: string | null;
    isMobile: boolean;
    handleBack: () => void;
}

const SubCategoriesContainer: React.FC<ItemsContainerProps> = ({
                                                                   categories,
                                                                   activeCategory,
                                                                   drillPath,
                                                                   isMobile,
                                                                   handleBack,
                                                               }) => {


    const filteredCategory = categories?.find(
        (cat) => cat.name === (isMobile ? drillPath : activeCategory)
    );

    const handleSubcategoryClick = (e: React.MouseEvent, url: string) => {
        e.preventDefault();
        window.location.href = url;
    };

    return (
        <div className={styles.itemsWrapper}>
            {filteredCategory?.subCategories?.map((subCat, index) => (
                <Link
                    key={subCat.name}
                    to={`/corals/${filteredCategory.name.toLowerCase()}/${subCat.name.toLowerCase()}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                    onClick={(e) =>
                        handleSubcategoryClick(
                            e,
                            `/corals/${filteredCategory.name.toLowerCase()}/${subCat.name.toLowerCase()}`
                        )
                    }
                >
                    <div className={styles.itemCard}  style={{ "--i": index } as React.CSSProperties}>
                        <img
                            src={subCat.imageUrl}
                            alt={subCat.name}
                            className={styles.itemImage}
                        />
                        <span>{subCat.name}</span>
                    </div>
                </Link>
            ))}
        </div>
    );
};

export default SubCategoriesContainer;
